export default "__VITE_ASSET__29581d8f__"